import { sysFetch } from '../fetch';
import type { ITableData } from '@/types';
import type {
  IArticle,
  IIndustryCase,
  ISystemNewProductArticlesParams,
  ISystemSlideshow,
  ISystemSlideshowParams,
} from './types';

/** 获取行业案例列表 */
export const fetchIndustryCases = data =>
  sysFetch.post<void, ITableData<IIndustryCase>>('/sysContentPage/query/industryCase', data);

/**获取 用户隐私协议 */
export const fetchPrivacyAgreement = () => sysFetch.post('/sysContentPage/query/protocols');

/**获取工业字典数据 */
export const fetchIndustrialDictionary = () =>
  sysFetch.post('/sysContentPage/query/industrialDictionary/categoryList');

/**
 * 分页查询轮播图
 * @deprecated 已废弃，推荐使用 fetchSystemSlideshow，调用方法一致
 */
export const queryCarouselChart = data => sysFetch.post('/sysRollPicture/getByPage', data);

/**获取首页视频 */
export const fetchMaacdeegmnnotu = data => sysFetch.post('documentManage/mall/getDocumentList', data);

/** 获取系统幻灯片列表 */
export const fetchSystemSlideshow = (data: ISystemSlideshowParams) =>
  sysFetch.post<void, ITableData<ISystemSlideshow>>('/sysRollPicture/getByPage', data);

/** 获取系统新品推荐文章列表 */
export const fetchSystemNewProductArticles = (data: ISystemNewProductArticlesParams) =>
  sysFetch.post<void, ITableData<IArticle>>('/sysContentPage/mall/page', data);

/**
 * 分页查询收件箱列表接口
 * @param data
 * @returns
 */
export const fetchNoticeList = (data) =>
  sysFetch.post('/notice/front/receive/getByPage', data);

/**
 * 标记已读
 * @param data
 * @returns
 */
export const labelRead = (data) =>
  sysFetch.post('/notice/read', data);

/**
 * 分类页展示查询
 * @param data
 * @returns
 */
export const queryClassifyListDisplay = data => 
  sysFetch.post('/documentManage/mall/getPreviewDocumentList', data);